import { TenantName } from '@shared/models/tenant-name';

export interface Withdraw {
    id?: string;
    contacts?: WithdrawContactInfo[];
    order_number?: string;
    ip_address?: string;
    created_date?: string;
    action_date?: string;
    updated_date?: string;
    trading_account?: string;
    payment_device_type?: string;
    crypto_wallet_address?: string;
    complete?: boolean;
    approved?: boolean;
    valid?: boolean;
    validate_response?: string;
    validate_date?: string;
    amount?: number;
    currency?: string;
    payment_device_data?: any;
    payment_device_id?: string;
    tenant?: TenantName;
    users_linked?: WithdrawUserLinked[];
    remain_amount?: number;
    cancelled?: boolean;
    denied?: boolean;
    showPayout?: boolean;
    member_code?: string;
    remark?: string;
    matched?: boolean;
}

export interface WithdrawUserLinked {
    id?: string;
    email?: string;
}

export interface WithdrawContactInfo {
    title?: string;
    first_name?: string;
    middle_name?: null;
    last_name?: string;
    role_lookup?: string;
}
